import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class Canardage extends ActionCard {
    static typeId = "CANARDAGE";
    static cardName = "Canardage";
    static colorHex = "#e3051b";
    static countInDeck = ACTION_CARD_COUNTS.CANARDAGE;
    static description = "Abattez 2 moutons adjacents mis en joue.";

    isValidOn(slotIndex, gameState) {
        if (slotIndex === 5) return false;
        const currentHasToken = gameState.lineOfFireSlots[slotIndex];
        const rightHasToken = gameState.lineOfFireSlots[slotIndex + 1];

        // Both the clicked slot and the one to its right MUST have tokens
        return currentHasToken.isTargeted && rightHasToken.isTargeted;
    }

    resolve(slotIndex, gameState) {
        gameState.resolveKills([slotIndex, slotIndex + 1], "CANARDAGE");
    }
}
